import { gql } from "@apollo/client";
import { TOKEN_FRAGMENT, EMPLOYEE_LOGIN_RESPONSE_FRAGMENT } from "../fragments/Auth";
import { BUSINESS_PROFILE_FRAGMENT } from "../fragments/User";

export const FIREBASE_LOGIN = gql`
  mutation firebaseLogin($idToken: String!, $phoneNumber: String, $email: String, $loginType: String!) {
    firebaseLogin(idToken: $idToken, phoneNumber: $phoneNumber, email: $email, loginType: $loginType) {
      businessProfile {
        ...BusinessProfileFields
      }
      token {
        ...TokenFields
      }
      hasBusinessProfile
      profileImage
      message
    }
  }
  ${BUSINESS_PROFILE_FRAGMENT}
  ${TOKEN_FRAGMENT}
`;

export const EMPLOYEE_LOGIN = gql`
  mutation EmployeeLogin($employeeId: String!, $password: String!) {
    employeeLogin(employeeId: $employeeId, password: $password) {
      ...EmployeeLoginResponseFields
    }
  }
  ${EMPLOYEE_LOGIN_RESPONSE_FRAGMENT}
`;

export const VERIFY_USER_EXIST = gql`
  mutation VerifyUserExist($recordType: String!, $empId: String, $email: String, $phone: String) {
    verifyUserExist(recordType: $recordType, empId: $empId, email: $email, phone: $phone) {
      isUserExist
      domain
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      token {
        accessToken
        email
        phoneNumber
        refreshToken
      }
      message
      hasBusinessProfile
      profileImage
    }
  }
`;
